export const links = {
  RGCamsMobile: "https://rgcams.com/landing/click/?AFNO=1-4",
  RGCamsDesktop: "https://rgcams.com/landing/click/?AFNO=1-11",
  RGAiDesktop: "https://a.aivanta76.com/3f5efc3b-2c2b-4963-bc39-d625144bf94d?adg=0&creative=ai_porn&spot=desktop_burger_menu",
  RGAiMobile: "https://a.aivanta76.com/3f5efc3b-2c2b-4963-bc39-d625144bf94d?adg=0&creative=ai_porn&spot=mobile_burger_menu",
};
